<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<div class="profile:flex profile:min-h-screen profile:flex-col">
  <myprofile-navigation></myprofile-navigation>
  <main class="profile:flex-1 profile:mb-fluid-lg">
    <div class="profile:grid-template profile:flex-1">
      <div class="profile:col-basic">
        <myprofile-page-title
          pageTitle="{{ 'pidp.pageHeader.title' | translate }}"
          [backLink]="false"
          [style.display]="checkShowPageTitle() ? 'block' : 'none'"
        >
        </myprofile-page-title>
        @if (checkShowPageTitle()) {
          <nav [attr.aria-label]="'pidp.pageHeader.title' | translate">
            <profile-pds-p-tabs-bar p-tabs-bar class="profile:mb-fluid-lg profile:sm:mb-fluid-md" [activeTabIndex]="getActiveTab()">
              @for (item of navigationItems; track item) {
                <a [href]="item.url" (click)="goToUrl(item.url ?? '', $event)">{{ item.text }}</a>
              }
            </profile-pds-p-tabs-bar>
          </nav>
        }
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
  <pid-art-footer
    [prefix]="'profile-pds'"
    [country]="currentCountry"
    [locale]="currentLanguage"
    [environment]="isProd ? 'p' : 'pp'"
    (languageChanged)="languageChanged($event)"
  />
</div>
